export default {"src":"https://web.cdn.greenlight.com/2.196.3/_next/static/media/arrow-white.e730b37f.svg","height":16,"width":26};